module.exports = __webpack_public_path__ + "media/2.ebbe1407.mp4";